export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
}

export const categories: Category[] = [
  { id: "cat-1", name: "明星八卦", slug: "star-gossip", description: "明星私生活、恋情曝光、家庭动态等一手八卦资讯" },
  { id: "cat-2", name: "影视综艺", slug: "tv-variety", description: "热门影视剧幕后故事、综艺节目爆料与内幕揭秘" },
  { id: "cat-3", name: "音乐圈", slug: "music-scene", description: "歌手动态、音乐节秘闻、专辑背后的故事" },
  { id: "cat-4", name: "网红爆料", slug: "influencer", description: "网红圈最新爆料、直播平台内幕与达人八卦" },
  { id: "cat-5", name: "国际娱乐", slug: "international", description: "好莱坞、韩娱、日娱等国际娱乐圈热点追踪" },
];

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);

export const getCategoryById = (id: string): Category | undefined =>
  categories.find((c) => c.id === id);